import { render, staticRenderFns } from "./SocialLinksModal.vue?vue&type=template&id=4b79a021"
import script from "./SocialLinksModal.vue?vue&type=script&lang=js"
export * from "./SocialLinksModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports